module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_SKU2.0029.png.51037008.jpg";